import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { useAuth } from "@/hooks/useAuth";
import NotFound from "@/pages/not-found";
import Landing from "@/pages/landing";
import Home from "@/pages/home";
import Profile from "@/pages/profile";
import Community from "@/pages/community";
import Subscribe from "@/pages/subscribe";
import ColorChart from "@/pages/color-chart";
import Artists from "@/pages/artists";
import Missions from "@/pages/missions";
import Onboarding from "@/pages/onboarding";
import CharacterCreation from "@/components/CharacterCreation";
import { useState } from "react";

function Router() {
  const { isAuthenticated, isLoading, user } = useAuth();
  const [showCharacterCreation, setShowCharacterCreation] = useState(false);

  if (showCharacterCreation) {
    return <CharacterCreation onComplete={() => setShowCharacterCreation(false)} />;
  }

  return (
    <Switch>
      {isLoading || !isAuthenticated ? (
        <>
          <Route path="/" component={Landing} />
          <Route path="/onboarding" component={Onboarding} />
        </>
      ) : (
        <>
          <Route path="/" component={Home} />
          <Route path="/profile" component={Profile} />
          <Route path="/community" component={Community} />
          <Route path="/subscribe" component={Subscribe} />
          <Route path="/color-chart" component={ColorChart} />
          <Route path="/artists" component={Artists} />
          <Route path="/missions" component={Missions} />
          <Route path="/onboarding" component={Onboarding} />
        </>
      )}
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Router />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
